<template>
  <el-dialog
    title="人工账户充值"
    :visible.sync="dialogVisible"
    width="450px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      ref="depositForm"
      :model="form"
      :rules="rules"
      label-width="100px"
      v-loading="loading"
    >
      <el-form-item label="充值金额" prop="amount">
        <el-input
          v-model="form.amount"
          placeholder="请输入充值金额"
        >
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="支付凭证">
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeaders"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :on-remove="handleUploadRemove"
          :file-list="fileList"
          :limit="1"
          :on-exceed="handleUploadExceed"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
        </el-upload>
      </el-form-item>
      
      <el-form-item label="备注">
        <el-input
          v-model="form.note"
          type="textarea"
          placeholder="请输入备注"
          :rows="3"
        ></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { manualPaGxbUserDeposit } from '@/api/member'

export default {
  name: 'Deposit',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    // 金额验证规则
    const validateAmount = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入充值金额'))
      } else if (!/^\d+(\.\d{1,2})?$/.test(value) || parseFloat(value) <= 0) {
        callback(new Error('请输入正确的金额'))
      } else {
        callback()
      }
    }
    
    return {
      dialogVisible: this.visible,
      loading: false,
      submitting: false,
      form: {
        amount: '',
        note: ''
      },
      rules: {
        amount: [
          { required: true, validator: validateAmount, trigger: 'blur' }
        ]
      },
      fileList: [],
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('jubao_admin_token') || localStorage.getItem('jubao_admin') || '')
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.resetForm()
    },
    
    resetForm() {
      this.$refs.depositForm.resetFields()
      this.form = {
        amount: '',
        note: ''
      }
      this.fileList = []
    },
    
    handleUploadSuccess(response, file, fileList) {
      this.fileList = fileList
      this.$message.success('上传成功')
    },
    
    handleUploadError(err, file, fileList) {
      this.$message.error('上传失败')
    },
    
    handleUploadRemove(file, fileList) {
      this.fileList = fileList
    },
    
    handleUploadExceed(files, fileList) {
      this.$message.warning('只能上传一个文件')
    },
    
    async handleSubmit() {
      this.$refs.depositForm.validate(async valid => {
        if (!valid) return
        
        this.submitting = true
        try {
          const params = {
            user_id: Number(this.userId),
            amount: parseFloat(this.form.amount),
            note: this.form.note
          }
          
          // 如果有上传文件，添加文件信息
          if (this.fileList.length > 0) {
            params.voucher_url = this.fileList[0].response?.url || this.fileList[0].url
          }
          
          const res = await manualPaGxbUserDeposit(params)
          if (res.err_code === 0) {
            this.$message.success('充值成功')
            this.$emit('success')
            this.handleClose()
          } else {
            this.$message.error(res.err_msg || '充值失败')
          }
        } catch (error) {
          console.error('充值失败:', error)
          this.$message.error('充值失败')
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}

.upload-demo {
  width: 100%;
}
</style>